import { Injectable } from '@angular/core';
import {en as enk} from '../environments/environments.k'
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class DecryptService {

  constructor() { }


  decryptUsingAES256(text:any) {
    
      let _key = CryptoJS.enc.Utf8.parse(enk.jumpOT);
      let _iv = CryptoJS.enc.Utf8.parse(enk.jumpOT);
      let decrypted = CryptoJS.AES.decrypt(
        text, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);
      return decrypted;
  }
}
